'use client';

import { Box } from '@mui/material';
import { Button } from 'components/button';
import { useI18n } from 'locales';
import PropTypes from 'prop-types';
import React from 'react';
import thousands from 'thousands';

function GiveButton({
  amount,
  isFetching,
  disabled,
}) {
  const t = useI18n();
  const isDisabled = disabled || isFetching || !(amount > 0);

  return (
    <Box sx={{ textAlign: 'center', mt: 4, pt: 2 }}>
      <Button
        variant="contained"
        size="large"
        type="submit"
        sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '1rem',
          px: 4,
          py: 1.5,
          borderRadius: '8px',
          '&:hover': {
            backgroundColor: 'primary.dark'
          }
        }}
        disabled={isDisabled}
      >
        {t('GIVE {{amount}} NOW', { amount: amount ? `${t('HKD')} ${thousands(amount)}` : '' })}
      </Button>
    </Box>
  );
}

GiveButton.propTypes = {
  amount: PropTypes.number,
  isFetching: PropTypes.bool,
  disabled: PropTypes.bool,
};

GiveButton.defaultProps = {
  isFetching: false,
  disabled: false,
};

export default GiveButton;
